import React, { useEffect } from "react";
import Modal from "react-responsive-modal";
import "../../styles/CustomModal.css";
import "react-responsive-modal/styles.css";
import styled from "styled-components";

const CheckAutoConfirmModal = (oProps: {
  isVisible: boolean;
  setVisible: any;
  onConfirm: any;
}) => {
  const onCloseModal = () => {
    oProps.setVisible(false);
  };

  useEffect(() => {
    if (oProps.isVisible) {
      const handleKey = (event: KeyboardEvent) => {
        if (event.key === "Enter") {
          oProps.onConfirm(false);
        }
      };
      window.addEventListener("keydown", handleKey);
      return () => {
        window.removeEventListener("keydown", handleKey);
      };
    }
  }, []);

  return (
    <Modal
      open={oProps.isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: "optionCustomOverlay",
        modal: "checkAutoConfirmModal",
      }}
      closeOnOverlayClick={false}
      showCloseIcon={false}
      animationDuration={150}
    >
      <Style>
        <div className="modal">
          <img
            className="closeIcon"
            onClick={onCloseModal}
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
            alt="ic"
          />

          <p className="titleFont">자동 주문접수 기능을 활성화 할까요?</p>
          <p className="subTitle">
            {
              "※주의: 자동 주문접수 기능을 활성화하면, 주문이 즉시 접수됨과\n동시에 주문서가 프린트되며 알림음이 1회만 발생합니다.\n준비시간은 미리 설정한 시간이 적용됩니다.\n주문 누락 가능성이 있는 매장은 사용을 권장하지 않습니다."
            }
          </p>

          <div className="bottomButtonWrap">
            <div className="confirmButton" onClick={oProps.onConfirm}>
            네, 주문이 누락되지 않는 환경입니다
            </div>
            <div className="cancelButton" onClick={onCloseModal}>
            아니오
            </div>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default CheckAutoConfirmModal;

const Style = styled.div`
  .modal {
    width: 100%;
  }

  .closeIcon {
    position: absolute;
    top: 5%;
    right: 4%;
    cursor: pointer;
  }

  .titleFont {
    padding-top: 60px;
    font-size: 28px;
    line-height: 40px;
    font-weight: 500;
    color: #000000;
    text-align: center;
  }
  .subTitle {
    padding-top: 20px;
    padding-bottom: 40px;
    font-size: 18px;
    line-height: 30px;
    font-weight: 400;
    color: #ff616b;
    text-align: center;
    white-space: pre-line;
    span {
      color: #ff616b;
      font-weight: 600;
    }
  }

  .bottomButtonWrap {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    .cancelButton {
      width: 100%;
      padding: 16px;
      font-size: 24px;
      line-height: 32px;
      border-radius: 10px;
      font-weight: 600;
      text-align: center;
      cursor: pointer;
      color: #ff616b;
      background: #ffffff;
      border: 1px solid #ff616b;
    }

    .confirmButton {
      width: 100%;
      padding: 16px 6px;
      font-size: 16px;
      line-height: 32px;
      letter-spacing: -1.5px;
      border-radius: 10px;
      font-weight: 600;
      text-align: center;
      cursor: pointer;
      color: #ffffff;
      background: #4dd2ae;
      border: 1px solid #4dd2ae;
    }
  }
`;
